import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../component/Navbar/Navbar';
import Footer from '../../component/Footer/Footer';
import { api } from '../../api/client';
import '../Login/login.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [errorList, setErrorList] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({});

  const toErrorList = (err) => {
    const bag = err?.data?.errors;
    if (bag && typeof bag === 'object') {
      const messages = Object.values(bag).flat().filter(Boolean);
      return messages.length > 0 ? messages : [err?.message || 'Could not process this request.'];
    }
    return [err?.message || 'Could not process this request right now.'];
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setErrorList([]);
    setFieldErrors({});
    setMessage('');
    try {
      const res = await api.post('/auth/forgot-password', { email }, null);
      setMessage(res?.message || 'If this email exists, a reset link has been sent.');
    } catch (err) {
      setErrorList(toErrorList(err));
      if (err?.data?.errors && typeof err.data.errors === 'object') {
        const perField = {};
        Object.entries(err.data.errors).forEach(([key, messages]) => {
          if (Array.isArray(messages) && messages.length > 0) {
            perField[key] = messages[0];
          }
        });
        setFieldErrors(perField);
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login">
      <Navbar />
      <div className="login-wrap">
        <div className="login-card">
          <h1 className="login-title">Forgot password</h1>
          <p className="login-subtitle">Enter your email and we will send you a secure reset link.</p>

          {message && <div className="login-success" role="status">{message}</div>}
          {errorList.length > 0 && (
            <div className="login-error" role="alert">
              <ul className="login-error-list">
                {errorList.map((msg, idx) => <li key={`${msg}-${idx}`}>{msg}</li>)}
              </ul>
            </div>
          )}

          <form onSubmit={handleSubmit} className="login-form-fields">
            <label className="login-label" htmlFor="forgot-email">Email</label>
            <input
              id="forgot-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className={`login-input${fieldErrors.email ? ' login-input-error' : ''}`}
              placeholder="you@example.com"
            />
            {fieldErrors.email && <small className="login-field-error">{fieldErrors.email}</small>}
            <button type="submit" disabled={submitting} className="login-btn">
              {submitting ? 'Sending…' : 'Send reset link'}
            </button>
          </form>

          <div className="login-meta-row">
            <Link to="/login" className="login-meta-link">Back to login</Link>
            <span className="login-meta-sep">•</span>
            <Link to="/signup" className="login-meta-link">Create account</Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ForgotPassword;
